export default __webpack_public_path__ + "static/media/heli-diver.baaf7779.jpg";